import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"],
  _excluded2 = ["onClick"];
import { pickToolTipName } from './lib/displayUtils';
import { Avatar } from './Avatar';
import { Tag } from 'foundations-components/transitional/components/Tag';
import { filterTokenProps } from 'foundations-components/utils/filterTokenProps';
import { jsx as _jsx } from "react/jsx-runtime";
const FLEX_WRAPPER_STYLES = {
  alignItems: 'center',
  gap: '100',
  blockSize: '32px'
};
export const AvatarTag = _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    restProps,
    tokenProps
  } = filterTokenProps(props);
  const {
      onClick
    } = restProps,
    restPropsWithoutOnClick = _objectWithoutPropertiesLoose(restProps, _excluded2);
  return /*#__PURE__*/_jsx(Tag, Object.assign({
    alignItems: "center",
    display: "inline-flex"
  }, restProps, tokenProps, {
    onClick: onClick,
    _flexWrapperStyles: FLEX_WRAPPER_STYLES,
    _avatar: /*#__PURE__*/_jsx(Avatar, Object.assign({}, restPropsWithoutOnClick, {
      size: "xs"
    })),
    children: children || pickToolTipName(props.lookup || {}) || props.displayName
  }));
};